import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fcc1083"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h1 text-center" }, "Kontakt", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-8 col-sm-12 offset-md-2 offset-sm-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@synchrokometa.cz" }, "info@synchrokometa.cz")
], -1))
const _hoisted_7 = { class: "text-center mb-5" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Kontakty na trenéry jednotlivých týmu ")
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-8 col-sm-12 offset-md-2 offset-sm-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h2" }, "Adresa", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sámova 1476/1, Praha 10 - Vršovice, 101 00", -1))
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    class: "w-100 kometa-mapycz",
    src: "https://frame.mapy.cz/s/kobebotata",
    frameborder: "0"
  })
], -1))
const _hoisted_15 = { class: "col-12 d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_form = _resolveComponent("contact-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_mapy_qr = _resolveComponent("mapy-qr")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_contact_form),
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, [
            _createVNode(_component_router_link, { to: { name: 'coachTeam' } }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_mapy_qr, { class: "kometa-mapyqr" })
            ])
          ])
        ])
      ])
    ])
  ]))
}